export default __webpack_public_path__ + "static/media/idVerify-desktop.2cd7dd1f.png";